import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=1d7ddfcc&scoped=true&"
import script from "./DownloadLink.vue?vue&type=script&lang=ts&"
export * from "./DownloadLink.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadLink.vue?vue&type=style&index=0&id=1d7ddfcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7ddfcc",
  null
  
)

export default component.exports